@if (!isDialogView) {
  <iw-title [title]="'ordersHistory.table.history' | translate">
    @if (areFiltersShown()) {
      <iw-button
        size="s"
        iconName="close"
        uiType="secondary"
        iconPosition="left"
        [disabled]="disabled"
        (click)="resetFilters()"
      >
        {{ "ordersHistory.filters.resetFilters" | translate }}
      </iw-button>
    }

    <iw-button
      size="s"
      iconName="filter"
      uiType="secondary"
      iconPosition="left"
      (click)="toggleFilters()"
      [isPressed]="areFiltersShown()"
    >
      {{
        (areFiltersShown()
          ? "ordersHistory.filters.hideFilters"
          : "ordersHistory.filters.showFilters"
        ) | translate
      }}
    </iw-button>
    @if (ongoingOrders() && !ongoingOrders().items.length) {
      <iw-button
        size="s"
        iconName="plus"
        uiType="primary"
        iconPosition="right"
        (click)="openWithdrawal()"
      >
        {{ "ordersHistory.dialog.table.createOrder" | translate }}
      </iw-button>
    }
  </iw-title>
}

@if (areFiltersShown() || isDialogView) {
  <form class="form" [formGroup]="filtersForm">
    <iw-date-range-picker
      [maxDate]="today"
      [useOutlineLabel]="false"
      [control]="dateRangeControl"
      [leftMonthToShowByDefault]="prevMonth"
      [label]="'ordersHistory.filters.date.label' | translate"
      [placeholder]="'ordersHistory.filters.date.placeholder' | translate"
    />

    <fu-select
      [items]="statuses"
      [clearable]="true"
      formControlName="status"
      [useOutlineLabel]="false"
      activeItemIcon="checkmark"
      [label]="'ordersHistory.filters.status' | translate"
      [placeholder]="'fu.select.placeholder' | translate"
    >
    </fu-select>

    @if (accountsCurrencies().length > 1) {
      <fu-select
        [clearable]="true"
        [useOutlineLabel]="false"
        formControlName="account"
        activeItemIcon="checkmark"
        [items]="accountsCurrencies()"
        [placeholder]="'fu.select.placeholder' | translate"
        [label]="'ordersHistory.filters.currency' | translate"
      >
      </fu-select>
    }

    @if (!isDialogView) {
      <iw-button
        size="m"
        uiType="primary"
        class="apply-btn"
        (click)="applyFilters()"
        [disabled]="!this.filtersForm.dirty"
      >
        {{ "ordersHistory.filters.applyFilters" | translate }}
      </iw-button>
    }
  </form>
  @if (isDialogView) {
    <iw-button
      size="l"
      fullWidth
      uiType="primary"
      class="apply-btn"
      (click)="applyFilters()"
      [disabled]="!this.filtersForm.dirty"
    >
      {{ "ordersHistory.filters.applyFilters" | translate }}
    </iw-button>
  }
}
